// extracted by mini-css-extract-plugin
module.exports = {"actionBar":"styles_actionBar__WYLkB","leftArrowIcon":"styles_leftArrowIcon__YcBf3","commentIcon":"styles_commentIcon__2GPqh"};